module.exports = __webpack_public_path__ + "img/1-1.41d99007.webp";